import { Sparkles, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative border-t border-gold/15 pt-16 pb-8 px-6 lg:px-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10 mb-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Sparkles className="w-6 h-6 text-gold" />
            <span className="font-display text-2xl font-bold">
              Magic <span className="gold-text">Seppe</span>
            </span>
          </div>
          <p className="text-[#B5A9C9] max-w-md text-sm leading-relaxed">
            Goochelaar & artiest uit Dilsen-Stokkem. Van intieme kinderfeesten tot
            grote themashows — Seppe brengt magie naar elk event.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[#B5A9C9]">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-gold" />
              <a
                href="https://wa.me/32468063847"
                target="_blank"
                rel="noreferrer"
                className="hover:text-gold transition-colors"
                data-testid="footer-whatsapp"
              >
                +32 468 06 38 47
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-gold" />
              <a
                href="mailto:info.magicseppe@gmail.com"
                className="hover:text-gold transition-colors"
                data-testid="footer-email"
              >
                info.magicseppe@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-gold" />
              <span>Dilsen-Stokkem, België</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Snel naar</h4>
          <ul className="space-y-2 text-sm text-[#B5A9C9]">
            <li><a href="/#over" className="hover:text-gold transition-colors">Over Seppe</a></li>
            <li><a href="/#shows" className="hover:text-gold transition-colors">Shows</a></li>
            <li><a href="/#galerij" className="hover:text-gold transition-colors">Galerij</a></li>
            <li><Link to="/agenda" className="hover:text-gold transition-colors" data-testid="footer-agenda-link">Agenda</Link></li>
            <li><a href="/#boeken" className="hover:text-gold transition-colors">Boeken</a></li>
          </ul>
        </div>
      </div>

      <div className="magical-divider" />
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 text-xs text-[#7A6C96]">
        <div>© {new Date().getFullYear()} Magic Seppe. Alle rechten voorbehouden.</div>
        <div className="italic font-display text-sm gold-text">"Geloof in de magie."</div>
      </div>
    </footer>
  );
}
